import { Upload, Bot, Trophy } from 'lucide-react';

import Container from './Container';
import Reveal from '../../../components/Reveal';

const STEPS = [
  {
    icon: Upload,
    title: 'Upload Your Notes',
    body: 'Drop in your notes, videos, PDFs, or lecture slides. SchoolHack handles any format you throw at it.',
  },
  {
    icon: Bot,
    title: 'AI Does the Magic',
    body: 'Andy instantly transforms your content into a complete, personalized study set — quizzes, flashcards, summaries, and more.',
  },
  {
    icon: Trophy,
    title: 'Study & Ace It',
    body: 'Practice with interactive tools, ask Andy anything, and walk into every exam with total confidence.',
  },
];

const HowItWorks = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-28">
      <div className="glow left-1/2 top-0 h-[360px] w-[600px] -translate-x-1/2 bg-accent/8" />

      <Container className="relative">
        <Reveal className="text-center">
          <span className="eyebrow">How It Works</span>
          <h2 className="font-heading mx-auto mt-5 max-w-2xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">From Notes to</span>
            <br />
            <span className="text-accent-grad">Exam-Ready in Minutes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-[0.95rem] text-white/55">
            Three simple steps to transform the way you study forever.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-8 md:grid-cols-3 lg:gap-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 120} className="relative">
              {/* green dashed connector into the next card */}
              {i < STEPS.length - 1 && (
                <span className="absolute left-full top-1/2 z-10 hidden h-0 w-8 -translate-y-1/2 border-t-2 border-dashed border-accent/60 md:block lg:w-10" />
              )}

              <div className="glass glass-hover flex h-full flex-col items-center rounded-2xl p-7 text-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/[0.04] text-accent ring-1 ring-white/10">
                  <s.icon size={22} />
                </span>
                <h3 className="font-heading mt-5 text-[1.2rem] font-semibold text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-[0.9rem] leading-relaxed text-white/55">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;
